export const fetchUpcomingEventsAction = data => {
	return {
		type: 'FETCH_UPCOMING_EVENTS_LIST',
		payload: data
	}
}